import cn from "classnames";
import TabIndexContext from "contexts/tabIndex";
import { composeValidators } from "helpers/validators";
import React, { Component } from "react";
import Field from "./field";

const formatRadius = (value) => {
    const digits = `${value ?? ""}`.replace(/\D/g, "");
    return digits ? parseInt(digits, 10) : null;
};

export default class GeoPicker extends Component {
    static contextType = TabIndexContext;
    state = { error: null, isValid: true };

    componentDidMount() {
        this.validate(this.props.value, { isValid: true });
    }

    validate(value, state) {
        const error = composeValidators(this.props.validators, value?.address);

        const nextState = { error: error || "", isValid: !error, ...state };
        this.setState(nextState);
    }

    setValue = () => {
        const { name, onChange, switchMap, value, disabled, withoutRadius } = this.props;
        if (disabled) {
            return;
        }
        const callback = (value) => {
            if (value && Object.keys(value).length) {
                this.validate(value);
                onChange({ name, value });
            }
            switchMap({ mode: "main", callback: null, withoutRadius: null });
        };

        switchMap({ mode: "picker", value, callback, withoutRadius });
    };

    setRadius = (data) => {
        const { name, onChange, value } = this.props;
        onChange({ name, value: { ...(value || {}), radius: formatRadius(data.value) } });
    };

    renderLabel = () => {
        const { label } = this.props;
        if (!label) {
            return null;
        }
        return (
            <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left field-wrap__label--required">
                {label}
            </label>
        );
    };

    renderError = () => {
        return <div className="field-wrap__error mt-1">{this.state.error}</div>;
    };

    clearField = (e) => {
        if (this.props.value?.address && this.props.isClearable) {
            e.stopPropagation();
            const { name, onChange } = this.props;
            onChange({ name, value: null });
        }
    };

    renderField = () => {
        const { value, button, label, index, inputBottomText, inputClassName, inputPlaceholder, isClearable } =
            this.props;
        const tabIndex = this.context?.baseTabIndex || 0;
        const props = {
            name: `pointElemGeozone_${index}`,
            type: "text",
            className: inputClassName || "field-wrap__input",
            readOnly: "readonly",
            placeholder: inputPlaceholder || "Адрес не задан",
            disabled: this.props.disabled,
            value: value && value.address ? value.address : "",
            tabIndex,
        };
        const buttonCname = cn({
            "field-wrap__button": true,
            "field-wrap__button--delete": value?.address && isClearable,
            [button]: !!button,
        });

        const fieldClasses = cn({
            "col-sm-8 col-md-9": label,
            "col-sm-12": !label,
            "field-wrap--invalid": !this.state.isValid,
        });
        return (
            <div className={fieldClasses} onClick={this.setValue}>
                <input {...props} />
                <div className={buttonCname} onClick={this.clearField} />
                {this.renderError()}
                {inputBottomText}
            </div>
        );
    };

    render() {
        const { value, index, withoutRadius } = this.props;
        return (
            <>
                <div className="row form-group">
                    {this.renderLabel()}
                    {this.renderField()}
                </div>
                {!withoutRadius && (
                    <Field
                        fieldWrapper="col-sm-8 col-md-5"
                        label="Радиус (м)"
                        inputProps={{
                            name: "radius",
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                        }}
                        index={index}
                        onChange={this.setRadius}
                        disabled={this.props.disabled}
                        value={value?.radius ?? ""}
                    />
                )}
            </>
        );
    }
}
